import gql from 'graphql-tag';

const alertRuleFragment = gql`
    fragment alertRuleFragment on AlertRule {
        id
        name
        description
        level
        project_id
        registry_id
        is_active
        alert_count
        alert_messages {
            message
            language
        }
        conditions {
            id
            name
            operator
            state
            value
            hysteresis
        }
        notifiers {
            action_url
            notifiable_type
            notifiable
        }
        updated_at
        deleted_at
    }
`;

const alertFragment = gql`
    fragment alertFragment on Alert {
        id
        rule_id
        device_id
        created_at
        stopped_at
    }
`;

const conditionsTriggeringFragment = gql`
    fragment conditionsTriggeringFragment on ConditionTriggering {
        is_triggering
        threshold_value
        state_value
        state_key
        operator
        threshold_hysteresis
        created_at
    }
`;

export const VIEW_NOTIFIABLE = gql`
    query getNotifiable($projectId: Int64!) {
        alertNotifiable(projectId: $projectId) {
            roles
            users {
                id
                name
                email
            }
        }
    }
`;

export const VIEW_ALERT_RULES = gql`
    query alertRules($projectId: Int64!, $filters: FiltersInput!) {
        alertRules(projectId: $projectId, filters: $filters) {
            data {
                id
                name
                level
                project_id
                registry_id
                is_active
                alert_count
            }
            pagination {
                per_page
                total
                last_page
                current_page
            }
        }
    }
`;

export const VIEW_ALERT_RULE = gql`
    query alertRule($projectId: Int64!, $id: Int64!) {
        alertRule(projectId: $projectId, id: $id) {
            id
            name
            description
            level
            project_id
            registry_id
            is_active
            alert_count
            alert_messages {
                message
                language
            }
            conditions {
                id
                name
                operator
                state
                value
                hysteresis
            }
            notifiers {
                notifiable_type
                notifiable
            }
            updated_at
            deleted_at
        }
    }
`;
export const STORE_ALERT_RULE = gql`
    mutation storeAlertRule($projectId: Int64!, $input: AlertRuleInput!) {
        storeAlertRule(projectId: $projectId, input: $input) {
            ...alertRuleFragment
        }
    }
    ${alertRuleFragment}
`;

export const UPDATE_ALERT_RULE = gql`
    mutation updateAlertRule(
        $projectId: Int64!
        $id: Int64!
        $input: AlertRuleUpdateInput!
    ) {
        updateAlertRule(projectId: $projectId, id: $id, input: $input) {
            ...alertRuleFragment
        }
    }
    ${alertRuleFragment}
`;

export const DELETE_ALERT_RULE = gql`
    mutation deleteAlertRule($projectId: Int64!, $id: Int64!) {
        deleteAlertRule(projectId: $projectId, id: $id) {
            ...alertRuleFragment
        }
    }
    ${alertRuleFragment}
`;

export const VIEW_ALERTS_BY_DEVICE = gql`
    query alertsByDevice($projectId: Int64!, $deviceId: Int64!, $filters: FiltersInput!) {
        alertsByDevice(projectId: $projectId, deviceId: $deviceId, filters: $filters) {
            data {
                ...alertFragment,
                conditions_triggering {
                ...conditionsTriggeringFragment
                }
            }
            pagination {
                from
                to
                per_page
                total
                last_page
                current_page
            }
        }
    }
    ${alertFragment}, ${conditionsTriggeringFragment}
`;

export const VIEW_ALERTS_BY_RULE = gql`
    query alertsByRule($projectId: Int64!, $ruleId: Int64!, $filters: FiltersInput!) {
        alertsByRule(projectId: $projectId, ruleId: $ruleId , filters: $filters) {
            data {
                ...alertFragment,
                conditions_triggering {
                ...conditionsTriggeringFragment
                }
            }
            pagination {
                from
                to
                per_page
                total
                last_page
                current_page
            }
        }
    }
    ${alertFragment}, ${conditionsTriggeringFragment}
`;

export const SUBSCRIPTION_ALERT = gql`
    subscription liveAlerts($projectId: Int64!) {
        liveAlerts(projectId: $projectId) {
            ...alertFragment
            conditions_triggering {
                ...conditionsTriggeringFragment
            }
        }
    }
    ${alertFragment}, ${conditionsTriggeringFragment}
`;

export const SUBSCRIPTION_ALERT_BY_RULE = gql`
    subscription liveAlertsByRule($projectId: Int64!, $ruleId: Int64!) {
        liveAlertsByRule(projectId: $projectId, ruleId: $ruleId) {
            ...alertFragment
            conditions_triggering {
                ...conditionsTriggeringFragment
            }
        }
    }
    ${alertFragment}, ${conditionsTriggeringFragment}
`;

export const VIEW_ALERT_COUNT_BY_PROJECT = gql`
    query alertCount($projectId: Int64!, $registryIds: [Int64!]!) {
        alertCount(projectId: $projectId, registryIds: $registryIds)
    }
`;
